import { render, staticRenderFns } from "./Tab.vue?vue&type=template&id=1bee7aec&"
import script from "./Tab.vue?vue&type=script&lang=js&"
export * from "./Tab.vue?vue&type=script&lang=js&"
import style0 from "./Tab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bee7aec')) {
      api.createRecord('1bee7aec', component.options)
    } else {
      api.reload('1bee7aec', component.options)
    }
    module.hot.accept("./Tab.vue?vue&type=template&id=1bee7aec&", function () {
      api.rerender('1bee7aec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UI/Tab.vue"
export default component.exports